import React from "react";
import Images from "../Constants/Images";
import { useTranslation } from "react-i18next";
import Colors from "../Constants/Color";
import ScrollAnimation from "react-animate-on-scroll";
import { useNavigate } from "react-router-dom";
import OwnRentals from "../Components/Home/OwnRentals";
const ManageYourProperty = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleContactUs = () => {
        navigate("/ContactUs");
    }
    return (
        <div style={{ backgroundColor: Colors.lightgoladn }} className="About_us">
            <OwnRentals />
            <div
                style={{ backgroundColor: Colors.lightgoladn }}
                className="pt-12 home_away py-10"
            >
                <div className=" text-center font-48 cinzel my-2  max-[1279px]:my-1 capitalize container ">
                    <ScrollAnimation animateIn="bounceInLeft">
                        {t("Leave it to the KŌZĒ team")}<br /><span className='showbr'></span>
                        {t("to unlock the full potential of your ")}<br /><span className='showbr'></span>
                        {t(" property")}
                    </ScrollAnimation>
                </div>
                <div className="container">
                    <div className="mt-10 overflow-hidden">
                        <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
                            <div className="flex flex-col md:flex-row gap-8  Here_center">
                                <div className="w-full md:w-1/2">
                                    <ScrollAnimation animateIn="bounceInLeft">
                                        <img
                                            src={Images.Managet}
                                            className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                                        />
                                    </ScrollAnimation>
                                </div>
                                <div  className="w-full md:w-1/2 mt-4">
                                    <ScrollAnimation animateIn="bounceInRight">
                                        <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                                            {t("Hassle-Free Management")}
                                        </div>
                                        <p className="text-left Optima collapse_txte font-24">
                                            {t("Leave the details to us. From guest communication to")}<br /><span className='showbr'></span>
                                            {t("maintenance coordination, our team handles every aspect")}<br /><span className='showbr'></span>
                                            {t("of rental management, allowing you to enjoy the")}<br /><span className='showbr'></span>
                                            {t("financial benefits without the headaches.")}<br /><span className='showbr'></span>
                                        </p>
                                    </ScrollAnimation >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-[#1B1C1C] py-10">
                <div className="container">
                    <div className=" overflow-hidden">
                        <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
                            <div className="flex flex-col md:flex-row gap-8  Here_center">
                                <div  className="w-full md:w-1/2 mt-4 text-white flex justify-center">
                                    <ScrollAnimation animateIn="bounceInLeft">
                                        <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                                            {t("Revenue Optimization")}
                                        </div>

                                        <p className="text-left Optima collapse_txte font-24">
                                            {t("We monitor the rental market on a daily basis and adjust")}<br /><span className='showbr'></span>
                                            {t("rates accordingly to optimize your property’s revenue.")}<br /><span className='showbr'></span>

                                        </p>
                                    </ScrollAnimation >
                                </div>
                                <div className="w-full md:w-1/2">
                                    <ScrollAnimation animateIn="bounceInRight">
                                        <img
                                            src={Images.Managet1}
                                            className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                                        />
                                    </ScrollAnimation>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{ backgroundColor: Colors.lightgoladn }}
                className=" home_away py-10"
            >
                <div className="container">
                    <div className=" overflow-hidden">
                        <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
                            <div className="flex flex-col md:flex-row gap-8  Here_center">
                                <div className="w-full md:w-1/2">
                                    <ScrollAnimation animateIn="bounceInLeft">
                                        <img
                                            src={Images.Managet2}
                                            className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                                        />
                                    </ScrollAnimation>
                                </div>
                                <div className="w-full md:w-1/2 mt-4">
                                    <ScrollAnimation animateIn="bounceInRight">
                                        <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                                            {t("Superior Guest Experience")}
                                        </div>
                                        <p className="text-left Optima collapse_txte font-24">
                                            {t("Happy guests are repeat guests. We focus on providing a")}<br /><span className='showbr'></span>
                                            {t("5-star experience, from seamless check-ins to prompt")}<br /><span className='showbr'></span>
                                            {t("responses and immaculate cleaning services. Our goal is")}<br /><span className='showbr'></span>
                                            {t("to exceed guest expectations.")}<br /><span className='showbr'></span>
                                        </p>
                                    </ScrollAnimation>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-[#1B1C1C] py-10 slashedzero">
                <div className=" text-center font-75 font-semibold cinzel my-2  max-[1279px]:my-1 text-white capitalize">
                    <ScrollAnimation animateIn="bounceInLeft">
                        {t("Our Services")}
                    </ScrollAnimation>
                </div>
                <div className="container">
                    <div className=" overflow-hidden">
                        <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
                            <div className="flex flex-col md:flex-row gap-8 max-[767px]:flex-col-reverse">
                                <div className="w-full md:w-1/2 mt-4 text-white border-r-2 border-cyan-50 p-3 pr-9 dot_jh ">
                                    <ScrollAnimation animateIn="bounceInLeft">
                                        <div className=" font-48 cinzel my-2  max-[1279px]:my-1  text-right max-[767px]:text-center capitalize ">
                                            {t("Listing Creation &")}
                                            <br /><span className='showbr'></span>
                                            {t("Optimization")}
                                        </div>
                                        <p className="text-right Optima collapse_txte font-24 max-[767px]:text-center">
                                            {t("We craft compelling listings with professional photos and")}<br /><span className='showbr'></span>
                                            {t("descriptions that highlight your property’s unique features.")}<br /><span className='showbr'></span>
                                        </p>
                                    </ScrollAnimation>
                                </div>
                                <div className="w-full md:w-1/2 ">
                                    <ScrollAnimation animateIn="bounceInRight">
                                        <div className="Optima Currency_count mt-10 ml-10" > 1</div>
                                    </ScrollAnimation>
                                </div>
                            </div>
                            <div className="flex flex-col md:flex-row gap-8">
                                <div className="w-full md:w-1/2 border-r-2 border-cyan-50 p-3 flex justify-end pr-9 dot_jh">
                                    <ScrollAnimation animateIn="bounceInLeft " className="max-[767px]:w-full">
                                        <div className="Optima Currency_count" > 2</div>
                                    </ScrollAnimation>
                                </div>
                                <div  className="w-full md:w-1/2  text-white  ">
                                    <ScrollAnimation animateIn="bounceInRight">
                                        <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 max-[767px]:text-center capitalize ">
                                            {t("Dynamic Pricing")}

                                        </div>
                                        <p className="text-left Optima collapse_txte font-24 max-[767px]:text-center">
                                            {t("Using advanced tools and market data, we set and adjust rates")}<br /><span className='showbr'></span>
                                            {t("to maximize your earnings.")}<br /><span className='showbr'></span>

                                        </p>
                                    </ScrollAnimation>
                                </div>
                            </div>
                            <div className="flex flex-col md:flex-row gap-8 max-[767px]:flex-col-reverse">
                                <div  className="w-full md:w-1/2  text-white border-r-2 border-cyan-50 p-3 pr-9 dot_jh">
                                    <ScrollAnimation animateIn="bounceInLeft">
                                        <div className=" font-48 cinzel my-2  max-[1279px]:my-1 text-right max-[767px]:text-center capitalize">
                                            {t("Guest Communication")}
                                        </div>
                                        <p className="text-right Optima collapse_txte font-24 max-[767px]:text-center">
                                            {t("Our team handles all guest inquiries, bookings, and support,")}<br /><span className='showbr'></span>
                                            {t("ensuring a smooth and enjoyable experience for every guest.")}<br /><span className='showbr'></span>

                                        </p>
                                    </ScrollAnimation>
                                </div>
                                <div className="w-full md:w-1/2 ">
                                    <ScrollAnimation animateIn="bounceInRight">
                                        <div className="Optima my-5 ml-10 Currency_count" > 3</div>
                                    </ScrollAnimation>
                                </div>
                            </div>
                            <div className="flex flex-col md:flex-row gap-8">
                                <div className="w-full md:w-1/2 border-r-2 border-cyan-50 p-3 flex justify-end pr-9 dot_jh">
                                    <ScrollAnimation animateIn="bounceInLeft" className="max-[767px]:w-full">
                                        <div className="Optima mr-10 Currency_count" > 4</div>
                                    </ScrollAnimation>
                                </div>
                                <div  className="w-full md:w-1/2  text-white ">
                                    <ScrollAnimation animateIn="bounceInRight">
                                        <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 max-[767px]:text-center capitalize">
                                            {t("Cleaning & Maintenance")}
                                        </div>
                                        <p className="text-left Optima collapse_txte font-24 max-[767px]:text-center">
                                            {t("We coordinate regular cleanings and maintenance, so your")}<br /><span className='showbr'></span>
                                            {t("property is always in top condition.")}<br /><span className='showbr'></span>
                                        </p>
                                    </ScrollAnimation>
                                </div>
                            </div>
                            <div className="flex flex-col md:flex-row gap-8 max-[767px]:flex-col-reverse">
                                <div className="w-full md:w-1/2  text-white border-r-2 border-cyan-50 p-3 pr-9 dot_jh">
                                    <ScrollAnimation animateIn="bounceInLeft" >
                                        <div className=" font-48 cinzel my-2  max-[1279px]:my-1 text-right max-[767px]:text-center capitalize">
                                            {t("Detailed Reporting")}
                                        </div>
                                        <p className="text-right Optima collapse_txte font-24 max-[767px]:text-center">
                                            {t("Stay informed with regular reports on occupancy, revenue, and")}<br /><span className='showbr'></span>
                                            {t("guest feedback, giving you full visibility into your property’s")}<br /><span className='showbr'></span>
                                            {t("performance.")}
                                        </p>
                                    </ScrollAnimation>
                                </div>
                                <div className="w-full md:w-1/2">
                                    <ScrollAnimation animateIn="bounceInRight">
                                        <div className="Optima my-12 ml-10 Currency_count" > 5</div>
                                    </ScrollAnimation>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{ backgroundColor: Colors.lightgoladn }}
                className="pt-12 home_away py-10"
            >
                <div className=" text-center font-75 font-semibold cinzel my-2  max-[1279px]:my-1 capitalize">
                    <ScrollAnimation animateIn="bounceInLeft">
                        {t("Benefits")}
                    </ScrollAnimation>
                </div>
                <div className="mt-10 overflow-hidden">
                    <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
                        <div className="flex flex-col md:flex-row gap-8">
                            <div className="w-full mt-4 md:w-1/2 text-center ">
                                <ScrollAnimation animateIn="none">
                                    <div className="sevices_icon m-auto Commitment">
                                        <img src={Images.female3} className="m-auto h-24 w-24 object-contain" />
                                    </div>
                                    <div className=" text-center font-48 cinzel my-2  max-[767px]:my-1 mt-10 capitalize">
                                        {t("No Commitment")}
                                    </div>
                                    <p className="text-center Optima collapse_txte font-24  mt-6 max-[767px]:mt-0">
                                        {t("We believe in earning your trust, not locking")}<br /><span className='showbr'></span>
                                        {t("you in. Our open-ended contracts give you")}<br /><span className='showbr'></span>
                                        {t("the flexibility to manage your property on")}<br /><span className='showbr'></span>
                                        {t("your terms, with no penalties for ending our")}<br /><span className='showbr'></span>
                                        {t("partnership.")}
                                    </p>
                                </ScrollAnimation>
                            </div>
                            <div className="w-full md:w-1/2 mt-4 text-center">
                                <div className="sevices_icon m-auto Commitment">
                                    <img src={Images.female2} className="m-auto  h-24 w-24 object-contain" />
                                </div>
                                <div className=" text-center font-48 cinzel my-2  max-[767px]:my-1 mt-10 capitalize">
                                    {t("Transparent Fees")}
                                </div>
                                <p className="text-center Optima collapse_txte font-24 mt-6 max-[767px]:mt-0">
                                    {t("Our management fees are among the most")}<br /><span className='showbr'></span>
                                    {t("in our markets, and we ensure full")}<br /><span className='showbr'></span>
                                    {t("transparency so you know exactly what you")}<br /><span className='showbr'></span>
                                    {t("are paying for.")}
                                </p>
                            </div>
                            <div className="w-full md:w-1/2 mt-4 text-center">
                                <ScrollAnimation animateIn="none">
                                    <div className="sevices_icon m-auto Commitment">
                                        <img src={Images.female1} className="m-auto h-24 w-24 object-contain" />
                                    </div>
                                    <div className=" text-center font-48 cinzel my-2  max-[767px]:my-1 mt-10 capitalize">
                                        {t("Dedicated Support")}
                                    </div>
                                    <p className="text-center Optima collapse_txte font-24  mt-6 max-[767px]:mt-0">
                                        {t("Our team is always available to answer your")}<br /><span className='showbr'></span>
                                        {t("questions, provide insights, and assist with")}<br /><span className='showbr'></span>
                                        {t("any issues that may arise. Your peace of")}<br /><span className='showbr'></span>
                                        {t("mind is our priority.")}<br /><span className='showbr'></span>
                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{ backgroundColor: Colors.lightgoladn }}
                className=" home_away py-16 "
            >
                <div className="container">
                    <div className="bg-black" style={{ borderRadius: "50px" }}>
                        <div className="flex flex-col md:flex-row gap-8  Here_center" style={{ alignItems: "top" }}>
                            <div  className="w-full md:w-1/2  text-white p-10  flex items-start">
                                <div className="">
                                    <div>
                                        <ScrollAnimation animateIn="none">
                                            <div className=" text-left font-48 cinzel  capitalize ">
                                                {t("Ready to ")}
                                                <br className="hidden" /><span className='showbr'></span>
                                                {t("Get Started?")}
                                            </div>
                                            <p className="text-left Optima collapse_txte font-30 mt-1">
                                                {t("Take the first step towards hassle-free property")}<br /><span className='showbr'></span>
                                                {t("management by contacting us today.")}<br /><span className='showbr'></span>
                                            </p>
                                            <button onClick={handleContactUs} className="white_class   mt-5  overflow-hidden  bg-white text-black Optima py-2 rounded-[10px] px-14 capitalize"> {t("Get On-Board")}</button>
                                        </ScrollAnimation>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full md:w-1/2 px-14 py-8">
                                <img src={Images.Managet3}
                                    className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ManageYourProperty;